import { normalizeRoleKey } from "./roleHelpers.mjs";
import { readAuthSession } from "./authSession.mjs";

export { hasAuthSession } from "./authSession.mjs";

// Pure auth/role/company resolution helpers extracted from NavigationDrawer.vue.
// They read the browser `localStorage` and are deterministic given that storage, so
// they can be unit-tested with a mocked localStorage. Since H3 PR 2 the JWT is only
// in the httpOnly cookie; a payload exists only for a legacy pre-H3 token.

export const parsePositiveId = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric) || numeric <= 0) return null;
  return Math.trunc(numeric);
};

export const decodeTokenPayload = () => readAuthSession()?.tokenPayload || null;

export const decodeTokenRoles = () => {
  const payload = decodeTokenPayload();
  const tokenRoles = Array.isArray(payload?.roles) ? payload.roles : [];
  return tokenRoles
    .map((entry) => {
      if (!entry) return null;
      if (typeof entry === "string") return entry;
      return entry.key || entry.role || entry.name || null;
    })
    .filter(Boolean);
};

export const resolveUserCompanyId = () => {
  const storedCompanyId = parsePositiveId(localStorage.getItem("user-company-id"));
  if (storedCompanyId) return storedCompanyId;
  return readAuthSession()?.companyId || null;
};

export const resolveUserEmployeeId = () => parsePositiveId(localStorage.getItem("user-employee-id"));

// Păstrează user-employee-id în pas cu /me (legat / dezlegat), ca meniul de comutare să nu rămână învechit.
export const storeUserEmployeeId = (profile) => {
  if (!profile || !Object.prototype.hasOwnProperty.call(profile, "employee_id")) return;
  const id = parsePositiveId(profile.employee_id);
  if (id) localStorage.setItem("user-employee-id", String(id));
  else localStorage.removeItem("user-employee-id");
};

export const resolveSelectedHrEmployeeId = () => parsePositiveId(localStorage.getItem("hr-dashboard:selected-employee-id"));

export const getRolesSetFromStorage = () => {
  const normalizedSet = new Set();
  let hasStored = false;
  try {
    const rawRoles = JSON.parse(localStorage.getItem("user-roles") || "[]");
    if (Array.isArray(rawRoles) && rawRoles.length) {
      hasStored = true;
      rawRoles.forEach((entry) => {
        if (!entry) return;
        const key = typeof entry === "string" ? entry : entry.key || entry.role;
        const norm = normalizeRoleKey(key);
        if (norm) normalizedSet.add(norm);
      });
    }
  } catch (_) {
    /* noop */
  }
  if (!hasStored) {
    const tokenRoles = decodeTokenRoles();
    tokenRoles.forEach((r) => {
      const norm = normalizeRoleKey(r);
      if (norm) normalizedSet.add(norm);
    });
  }
  const legacy = normalizeRoleKey(localStorage.getItem("user-role"));
  if (legacy) normalizedSet.add(legacy);
  return normalizedSet;
};
